export enum DrugInteractionAlertsFilterOption {
    ShowAllAlertLevels = 0,
    ShowAlertLevel1Only = 1,
    ShowAlertLevel1And2Only = 2
}
